export default "__VITE_ASSET__CHRRHlw$__"